var _ = require('underscore');

var React = require("react");
var ReactDOM = require("react-dom");
var DropdownOption = require('./DropdownOption.jsx');
const createReactClass = require("create-react-class");

var InviteForm = createReactClass({

	getInitialState: function() {
		return {
			status: 'ready',
			visible: false
		};
	},

	componentDidUpdate: function() {
		if(this.state.visible) {
			$(ReactDOM.findDOMNode(this)).find('select').select2("destroy");
			$(ReactDOM.findDOMNode(this)).find('select').select2();
			var email = ReactDOM.findDOMNode(this.refs.email);
			email.focus();
		}
	},

	handleSubmit: function(e) {
		e.preventDefault();

		if(this.state.status === 'ready') {
			this.setState({status: 'submitting'});

			var email = ReactDOM.findDOMNode(this.refs.email);
			var role = ReactDOM.findDOMNode(this.refs.role);

			this.props.handleInvite(email, role);

			this.setState({status: 'ready'});
		}
	},

	toggleForm: function(e) {
		e.preventDefault();
		this.setState({visible: !this.state.visible});
	},

	render: function() {
		var roles = _.map(this.props.model.Roles, function(item) {
			return (
				<DropdownOption value={item.GroupID} text={item.RoleTitle} key={item.GroupID} />
			);
		});

		var formClass = 'form-inline invite-form hide-form';
		var button;

		if (this.props.model.CanInvite) {
			button = (
				<div className="col-md-12">
					<div className="btn-toolbar pull-right">
						<button
							className="btn btn-default"
							ref="securityButton"
							type="button"
							onClick={this.props.handleSecuritySettings}
						>
							Security settings
						</button>
						<button
							className="btn btn-primary"
							ref="inviteButton"
							onClick={this.toggleForm}
						>
							<i className="fa fa-user" /> Invite user
						</button>
					</div>
				</div>
			);
		}

		if(this.state.visible) {
			button = null;
			formClass = 'form-inline invite-form';
		}

		return (
			<div>
				<form
					action={this.props.context.inviteForm.action}
					method="post"
					className={formClass}
					ref="inviteForm"
					onSubmit={this.handleSubmit}
				>
					<fieldset className="row">
						<div className="form-group col-md-4">
							<label htmlFor="email">Email</label>
							<input ref="email" type="email" placeholder="example@email.com" className="form-control" />
						</div>
						<div className="form-group col-md-4">
							<label htmlFor="role">Role</label>
							<select ref="role" className="form-control">
								{roles}
							</select>
						</div>
						<div className="form-group form-actions col-md-4">
							<button type="submit" className="btn btn-primary btn-wide">Invite</button>
							<button	onClick={this.toggleForm} className="btn btn-link btn-wide">Cancel</button>
						</div>
						{button}
					</fieldset>
				</form>
			</div>
		);
	}

});

module.exports = InviteForm;
